const dotenv = require( 'dotenv' )
dotenv.config()

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('../views/Home.vue'),
        meta: {
          title: `${ process.env.VUE_APP_ORG }: ${ process.env.VUE_APP_SLOGAN }`
        }
    },
    {
        path: '/terms',
        name: 'Terms',
        component: () => import('../views/Terms.vue'),
        meta: {
          title: `${ process.env.VUE_APP_ORG }: Conditions d'utilisation`
        }
    },
    {
        path: '/privacy',
        name: 'Privacy',
        component: () => import('../views/Privacy.vue'),
        meta: {
          title: `${ process.env.VUE_APP_ORG }: Politique de confidentialité`
        }
    },
    { 
        path: '/page-not-found', 
        name: 'NotFound',
        component: () => import('../views/NotFound.vue'),
        meta: {
          title: 'Not Found'
        }
    },
    { 
        path: '*', 
        redirect: '/page-not-found'
    },
]

module.exports = routes